<template>
  <li>
    <router-link
      v-slot="{ href, isActive, navigate }"
      :to="menuItem.toState"
      custom
    >
      <a
        :href="href"
        class="side-menu-item"
        :class="{
          'is-active': !hasChildren && (isActive || isChildMenuActive),
        }"
        :rel="
          menuItem.openInNewPage ? 'noopener noreferrer nofollow' : undefined
        "
        :target="menuItem.openInNewPage ? '_blank' : undefined"
        @click="navigate"
      >
        <nav-icon v-if="menuItem.iconSrc" :src="menuItem.iconSrc" />
        <fluent-icon v-else :icon="menuItem.icon" size="24" />
        <span class="flex-1 min-w-0 truncate">
          {{ $t(`SIDEBAR.${menuItem.label}`) }}
        </span>
        <span
          v-if="hasChildren"
          role="button"
          tabindex="0"
          class="side-menu-chevron"
          :class="{ 'is-open': isOpen }"
          :aria-label="$t(`SIDEBAR.${menuItem.label}`)"
          :aria-expanded="isOpen ? 'true' : 'false'"
          @click.prevent.stop="$emit('toggle')"
          @keydown.enter.prevent.stop="$emit('toggle')"
          @keydown.space.prevent.stop="$emit('toggle')"
        >
          <nav-icon :src="chevronSrc" />
        </span>
      </a>
    </router-link>
    <slot v-if="hasChildren && isOpen" />
  </li>
</template>

<script>
import NavIcon from './NavIcon.vue';
import chevronSrc from 'dashboard/assets/images/sidebar/chevron-down.svg';

export default {
  components: { NavIcon },
  props: {
    menuItem: {
      type: Object,
      default: () => ({}),
    },
    isChildMenuActive: {
      type: Boolean,
      default: false,
    },
    hasChildren: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chevronSrc,
    };
  },
  mounted() {
    if (this.isChildMenuActive) {
      this.$el.firstElementChild.scrollIntoView({ block: 'nearest' });
    }
  },
};
</script>
